import { render, staticRenderFns } from "./OzoneMonitor.vue?vue&type=template&id=055f76e1&scoped=true&"
import script from "./OzoneMonitor.vue?vue&type=script&lang=js&"
export * from "./OzoneMonitor.vue?vue&type=script&lang=js&"
import style0 from "./OzoneMonitor.vue?vue&type=style&index=0&id=055f76e1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f76e1",
  null
  
)

export default component.exports